import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { Playlist, Song } from './playlistSlice'

interface State extends GetFavsResponse {}

interface GetFavsResponse {
  playlists?: Playlist[]
  songs?: Song[]
}

export const initialState: Partial<State> = {}

export const attemptGetFavs = createAsyncThunk<GetFavsResponse, void>(
  'favs/get',
  async () => {
    const response = await $api.post('favs/list')
    return response.data
  },
)

export const attemptAddPlaylistToFavs = createAsyncThunk<void, string>(
  'favs/add/playlist',
  async (playlistId) => {
    await $api.post('favs/add/playlist', { id: playlistId })
  },
)

export const attemptDeletePlaylistFromFavs = createAsyncThunk<void, string>(
  'favs/delete/playlist',
  async (playlistId) => {
    await $api.post('favs/delete/playlist', { id: playlistId })
  },
)

export const attemptAddSongToFavs = createAsyncThunk<void, string>(
  'favs/add/song',
  async (songId) => {
    await $api.post('favs/add/song', { id: songId })
  },
)

export const attemptDeleteSongFromFavs = createAsyncThunk<void, string>(
  'favs/delete/song',
  async (songId) => {
    await $api.post('favs/delete/song', { id: songId })
  },
)

export const favsSlice = createSlice({
  name: 'favs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptGetFavs.fulfilled, (state, { payload }) => {
      state.playlists = payload.playlists
      state.songs = payload.songs
    })
    builder.addCase(attemptAddPlaylistToFavs.pending, (state, action) => {
      // Optimistic update - add playlist immediately
      const playlistId = action.meta.arg
      if (!state.playlists) state.playlists = []
      // Note: We'll need the full playlist object for proper display
      // This will be updated when attemptGetFavs is called
    })
    builder.addCase(attemptDeletePlaylistFromFavs.pending, (state, action) => {
      // Optimistic update - remove playlist immediately
      const playlistId = action.meta.arg
      if (state.playlists) {
        state.playlists = state.playlists.filter((p) => p._id !== playlistId)
      }
    })
    builder.addCase(attemptAddSongToFavs.pending, (state, action) => {
      // Optimistic update - add song immediately
      const songId = action.meta.arg
      if (!state.songs) state.songs = []
    })
    builder.addCase(attemptDeleteSongFromFavs.pending, (state, action) => {
      // Optimistic update - remove song immediately
      const songId = action.meta.arg
      if (state.songs) {
        state.songs = state.songs.filter((s) => s._id !== songId)
      }
    })
  },
})

export default favsSlice.reducer
